import React, { Component } from "react";
import Big from "big.js";
import { nestedParameter } from "util";
import { FormattedNumber } from "react-intl";

import Paper from "material-ui-next/Paper";
import Switch from "material-ui-next/Switch";

import { DataTable, Loadable, IconButton } from "components/support";

import { withStyles } from "material-ui-next/styles";
import { colors } from "assets";

const Toggle = withStyles({
  bar: {
    backgroundColor: colors.switch.primary,
    opacity: 0.3
  },
  checked: {
    color: colors.switch.primary,
    transform: "translateX(14px)",
    "& + $bar": {
      backgroundColor: colors.switch.primary,
      opacity: 0.5
    }
  }
})(Switch);

class DataTableView extends Component {
  config = {
    identifier: "uuid",
    columns: [
      {
        accessor: "uuid",
        show: false
      },
      {
        id: "name",
        accessor: "name",
        Header: "Nome do Grupo",
        type: "custom",
        Cell: props => this.parseField(props.row._original, "name")
      },
      {
        id: "enabled",
        accessor: "enabled",
        Header: "Habilitar/Desabilitar",
        align: "center",
        Cell: props => this.parseSwitchField(props.row._original, "enabled")
      },
      {
        id: "actions",
        Header: "Ações",
        align: "right",
        sortable: false,
        Cell: props => this.parseActionsField(props.row._original)
      }
    ]
  };

  parseField = (obj, field) => {
    return (
      <p className={!!obj.deleted ? "field-deleted" : ""}>
        {nestedParameter(obj, field)}
      </p>
    );
  };

  parseSwitchField = optGroup => {
    const { presenter } = this.props;

    return (
      <p>
        <Toggle
          checked={optGroup.enabled}
          onChange={(_, checked) =>
            presenter.onChangeSwitch(optGroup.name, optGroup.uuid, checked)
          }
        />
      </p>
    );
  };

  parseMoneyField = (obj, field) => (
    <p className={!!obj.deleted ? "field-deleted" : ""}>
      <FormattedNumber
        value={Big(nestedParameter(obj, field)).div(100)}
        format="BRL"
      />
    </p>
  );

  parseActionsField = optional => {
    const { presenter } = this.props;

    return (
      <div>
        <IconButton
          mini
          icon="search"
          onClick={() => presenter.onViewOptionalGroup(optional)}
        />

        {!optional.deleted && (
          <span>
            <IconButton
              mini
              icon="mode_edit"
              onClick={() => presenter.onEditOptionalGroup(optional)}
            />
            <IconButton
              mini
              icon="delete"
              onClick={() => presenter.onDeleteOptionalGroup(optional)}
            />
          </span>
        )}
      </div>
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      nextProps.presenter.onFilterChange(nextProps.filter);
    }
  }

  handleDataTableChange = ({ field, value }) => {
    const { presenter } = this.props;
    presenter.onOrderChange(field, value);
  };

  handlePageChange = page => {
    const { presenter } = this.props;
    presenter.onPageChange(page + 1);
  };

  render() {
    const { loading, resultSet, pagination, order } = this.props.viewModel;
    return (
      <div className="mt-md">
        <h3 style={{ textAlign: "right", padding: 10, margin: 0 }}>
          {pagination.total} opcional(is) encontrado(s).
        </h3>
        <Paper elevation={1} className="optional__content">
          <Loadable loading={loading}>
            <DataTable
              manual
              resultSet={resultSet}
              total={pagination.total}
              perPage={pagination.perPage}
              page={pagination.currentPage}
              config={this.config}
              onChange={this.handleDataTableChange}
              orderField={order.field}
              orderDirection={order.direction}
              onPageChange={this.handlePageChange}
            />
          </Loadable>
        </Paper>
      </div>
    );
  }
}

export default DataTableView;



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/list/data-table/view.jsx